var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCanvasnew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#e53935",
    d: "M29.93,4.89C29.5,7.78,27.01,10,24,10s-5.5-2.22-5.93-5.11C19.95,4.31,21.94,4,24,4 S28.05,4.31,29.93,4.89z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#e53935",
    d: "M14.1,14.1c-2.12,2.12-5.45,2.32-7.79,0.58c1.87-3.57,4.8-6.5,8.37-8.37 C16.42,8.65,16.22,11.98,14.1,14.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#e53935",
    d: "M10,24c0,3.01-2.22,5.5-5.11,5.93C4.31,28.05,4,26.06,4,24s0.31-4.05,0.89-5.93 C7.78,18.5,10,20.99,10,24z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#e53935",
    d: "M14.68,41.69c-3.57-1.87-6.5-4.8-8.37-8.37c2.34-1.74,5.67-1.54,7.79,0.58S16.42,39.35,14.68,41.69z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#e53935",
    d: "M29.93,43.11C28.05,43.69,26.06,44,24,44s-4.05-0.31-5.93-0.89C18.5,40.22,20.99,38,24,38 S29.5,40.22,29.93,43.11z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#e53935",
    d: "M41.69,33.32c-1.87,3.57-4.8,6.5-8.37,8.37c-1.74-2.34-1.54-5.67,0.58-7.79S39.35,31.58,41.69,33.32z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#e53935",
    d: "M44,24c0,2.06-0.31,4.05-0.89,5.93C40.22,29.5,38,27.01,38,24s2.22-5.5,5.11-5.93 C43.69,19.95,44,21.94,44,24z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#e53935",
    d: "M41.69,14.68c-2.34,1.74-5.67,1.54-7.79-0.58s-2.32-5.45-0.58-7.79 C36.89,8.18,39.82,11.11,41.69,14.68z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 14,
    r: 2,
    fill: "#e53935"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.929,
    cy: 16.929,
    r: 2,
    fill: "#e53935"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 24,
    r: 2,
    fill: "#e53935"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.929,
    cy: 31.071,
    r: 2,
    fill: "#e53935"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 34,
    r: 2,
    fill: "#e53935"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.071,
    cy: 31.071,
    r: 2,
    fill: "#e53935"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 24,
    r: 2,
    fill: "#e53935"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.071,
    cy: 16.929,
    r: 2,
    fill: "#e53935"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanvasnew);
export default __webpack_public_path__ + "static/media/canvasnew.6f7d24d77806be2f914523c210aace27.svg";
export { ForwardRef as ReactComponent };